import {Button} from "@mui/material";
import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {Link} from "react-router-dom";

function ManageAccountMenu(props) {
    const items = props.items;
    const children = props.children;
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const menuItems = items.map((item) => (item.text ?
            <Link to={item.url}>
                <MenuItem
                    onClick={handleClose}
                    sx={{backgroundColor: "white", color: '#1251b0'}}
                >
                    {(item.icon) ? (item.icon) : ""} &nbsp;
                    {item.text}
                </MenuItem>
            </Link> : ""
    ));

    return (
        <div style={{marginLeft: "0px"}}>
            <Button
                onClick={handleClick}
                sx={{color: 'white', fontWeight: '500', padding: 0}}
            >
                {children}
            </Button>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {menuItems}
            </Menu>
        </div>
    );
}

export default ManageAccountMenu;
